import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import  { ExportView } from "./export-view"

export class ExportViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new ExportView();
    }
    public getTypeId(): string {
        return "VM-1519B3A3-5DE9-4FD9-B87C-7284C0DF8D17"
    }

    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    
    close(){
        this.closePopup();
    }
}
